module.exports = __webpack_public_path__ + "static/toiture_icon-eb16fa7959b858d168053637638989ad.jpg";